export const parseAsBoolean = (value: unknown): boolean | null => {
  if (value === undefined) return null;
  if (value === null) return null;
  if (value === '') return null;

  if (typeof value === 'string') {
    const lowered = value.toLowerCase();
    const isTrue = lowered === 'true' || lowered === '1';
    const isFalse = lowered === 'false' || lowered === '0';
    if (!isTrue && !isFalse) return null;

    if (isTrue) return true;
    if (isFalse) return false;
  }

  if (typeof value === 'boolean') return value;

  if (typeof value === 'number') {
    if (value === 0) return false;
    if (value === 1) return true;
    return null;
  }

  // Cannot be parsed
  return null;
};
